import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  tid: number;
  field_category_name: string;
  field_category_name_ms: string;
  field_category_name_zh: string;
  field_category_order_sequence: string;
  field_category_store_locations?: string;
  field_category_published?: boolean;
  field_category_status: string;
  field_category_created_at: string;
  field_category_updated_at: string;
}

const fetchCategoriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/get-categories/${id}`);
  return response.data[0];
};

const useCategoriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["categoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchCategoriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCategoriesDocumentDetails };
